import React from "react";
import video1 from "../../assets/vitt-vichaar/1.webm";
import video2 from "../../assets/vitt-vichaar/2.webm";
import video3 from "../../assets/vitt-vichaar/3.webm";
import video4 from "../../assets/vitt-vichaar/4.webm";
import video5 from "../../assets/vitt-vichaar/5.webm";

const VideoCards = () => {
  const videos = [video4, video1, video2, video3, video5];

  return (
    <div className="mx-auto px-8 py-12">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
        {videos.map((video, index) => (
          <div
            key={index}
            className="w-full bg-white rounded-lg shadow-lg overflow-hidden"
          >
            <video className="w-full h-auto object-cover" autoPlay loop muted>
              <source src={video} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VideoCards;
